var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "module-info sip-view-empty", attrs: { role: "region" } },
    [
      _vm.icon
        ? _c(
            "div",
            {
              staticClass: "module-info__icon-wrap",
              attrs: { "aria-hidden": "true" },
            },
            [_c("i", { class: ["fa", "fa-" + _vm.icon] })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.title
        ? _c("h4", { staticClass: "module-info__title" }, [
            _vm._v(_vm._s(_vm.trans(_vm.module + "." + _vm.title))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.description
        ? _c("p", { staticClass: "module-info__desc" }, [
            _vm._v(_vm._s(_vm.trans(_vm.module + "." + _vm.description))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("btn"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }